import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4001/api';

const page = {
  minHeight: '100vh',
  boxSizing: 'border-box',
  backgroundImage: 'url(/BESCOM_SSO_BG_Image.png)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '20px',
};

const card = {
  background: 'rgba(255, 255, 255, 0.65)',
  backdropFilter: 'blur(12px)',
  WebkitBackdropFilter: 'blur(12px)',
  border: '1px solid rgba(255, 255, 255, 0.5)',
  borderRadius: '16px',
  padding: '48px 40px',
  width: '100%',
  maxWidth: '420px',
  boxShadow: '0 20px 60px rgba(0, 0, 0, 0.35)',
};

const btn = {
  padding: '12px 24px',
  background: 'linear-gradient(135deg, #009FE3 0%, #0072B1 100%)',
  color: '#fff',
  border: 'none',
  borderRadius: '10px',
  fontSize: '15px',
  fontWeight: '600',
  cursor: 'pointer',
  marginTop: '8px',
};

export default function ConfirmEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  // 'ready' | 'confirming' | 'success' | 'error'
  //
  // CONFIRMED BUG (2026-08-04): this used to fire the confirmation request
  // automatically in a useEffect on page load. Corporate mail security
  // (Microsoft 365 Defender "Safe Links" and similar) pre-fetches every
  // link in an incoming email to scan it — including this one — often
  // executing the page's JS while doing so. That silently consumed the
  // one-time token before the person ever opened the email themselves,
  // clearing registration.js's email gate early and exposing the TOTP
  // step before the real confirmation ever happened (only ever seen with
  // @bescom.co.in addresses, never Gmail — exactly the domains with this
  // kind of scanning). Now requires an actual button click — scanners
  // load/render the page but essentially never simulate a real click.
  const [status, setStatus] = useState('ready');
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('This confirmation link is missing its token.');
    }
  }, [token]);

  function handleConfirm() {
    setStatus('confirming');
    fetch(`${API_BASE}/account/confirm-email?token=${encodeURIComponent(token)}`)
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) {
          setStatus('error');
          setMessage(data.error || 'This link is invalid or has expired.');
          return;
        }
        setStatus('success');
        setMessage(data.email || '');
      })
      .catch(() => {
        setStatus('error');
        setMessage('Could not reach the account service.');
      });
  }

  return (
    <div style={page}>
      <div style={card}>
        <img src="/bescom-logo-ui.png" alt="BESCOM" style={{ width: '80px', marginBottom: '16px' }} />

        {status === 'ready' && (
          <>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              Click below to confirm this email address for your BESCOM account.
            </p>
            <button onClick={handleConfirm} style={btn}>
              Confirm Email Address
            </button>
          </>
        )}

        {status === 'confirming' && (
          <p style={{ color: '#666' }}>Confirming your email address…</p>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>✅</div>
            <p style={{ fontWeight: '600', marginBottom: '8px' }}>Email confirmed</p>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              <strong>{message}</strong> is now set on your account. You can close this tab
              and return to where you were — whether that's finishing registration or the
              page you clicked "Add Email" from, it'll pick up automatically.
            </p>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: '40px', marginBottom: '16px' }}>❌</div>
            <p style={{ fontWeight: '600', marginBottom: '8px' }}>Something went wrong</p>
            <p style={{ color: '#666', fontSize: '14px', marginBottom: '20px' }}>{message}</p>
            <button onClick={() => navigate('/')} style={btn}>
              Go to Homepage
            </button>
          </>
        )}
      </div>
    </div>
  );
}
